export enum ErapDeliveryStatus {
  Pending = 'Pending',
  Processing = 'Processing',
  Sent = 'Sent',
  Failed = 'Failed',
  DeadLetter = 'DeadLetter',
}

export interface IErapDeliveryModel {
  id: string;
  sourceMessageId: string;
  erapMessageId: string;
  status: ErapDeliveryStatus;
  attemptCount: number;
  maxAttempts: number;
  nextAttemptAt: string;
  returnValue: string;
  faultCode: string;
  faultString: string;
  erapError: string;
  lastError: string;
  createdAt: string;
  updatedAt: string;
  sentAt: string;
  callerId: string;
  deviceSource: string;
  plateNumber: string;
}

export interface IErapDeliveryDetailModel {
  delivery: IErapDeliveryModel;
  requestXml: string;
  responseXml: string;
}

export interface IErapDeliveryAttemptModel {
  attemptNo: number;
  at: string;
  outcome: string;
  returnValue: string;
  faultCode: string;
  faultString: string;
  erapError: string;
  error: string;
  responseXml: string;
}

export interface IErapDeliveryStatsModel {
  total: number;
  pending: number;
  processing: number;
  sent: number;
  failed: number;
  deadLetter: number;
  oldestPendingAt?: string;
  sentLastHour?: number;
}

export enum ErapDeliveryMode {
  Off = 'Off',
  Manual = 'Manual',
  Auto = 'Auto',
}

export interface IErapDeliveryControlModel {
  callerId: string;
  mode: ErapDeliveryMode;
  ratePerMinute: number;
  updatedAt: string;
  updatedBy: string;
}

export interface IErapDeliveryControlUpdateModel {
  mode: ErapDeliveryMode;
  ratePerMinute: number;
}

export interface IErapDeliverySendResult {
  id: string;
  outcome: string;
  erapError?: string;
  faultCode?: string;
}

export interface IErapDeliveryFilter {
  callerId?: string;
  from?: string;
  to?: string;
  status?: ErapDeliveryStatus[];
  search?: string;
  page?: number;
  pageSize?: number;
}
